const mockGates: Record<string, boolean> = {}

const mockExperiments: Record<string, Record<string, unknown>> = {
  /* Example of use :
  'experiment-tme-tutorial-update': {
    variant: 'control',
  },
  */
}

export class StatsigDevMock {
  checkGate(name: string): boolean {
    console.log(`[StatsigDevMock] checkGate: ${name} = ${mockGates[name] ?? false}`)
    return mockGates[name] ?? false
  }

  getExperiment(name: string) {
    const value = mockExperiments[name] ?? {}
    console.log(`[StatsigDevMock] getExperiment: ${name} =`, value)
    return {
      name,
      value,
      get: (key: string, fallback?: unknown) => value[key] ?? fallback,
    }
  }

  logEvent(eventName: string, value?: string | number, metadata?: Record<string, string>): void {
    console.log(`[StatsigDevMock] logEvent: ${eventName}`, { value, metadata })
  }
}

export const statsigDevMock = new StatsigDevMock()
